module.exports = __webpack_public_path__ + "img/clash.f45f95d7.jpg";